import React, { useEffect, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';
const IntegerBattle = () => {
  const levelCount = 5;
  const questionsPerLevel = 8;
  const [level, setLevel] = useState(1);
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [showGameOver, setShowGameOver] = useState(false);

  useEffect(() => {
    setQuestions(generateRandomQuestions());
    createNumberRain();
  }, []);

  useEffect(() => {
    if (questions.length > 0) {
      displayQuestion();
    }
  }, [questions, currentQuestion]);

  useEffect(()=>{
    
    if(score===50){
          const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    }
  },[score])

  const generateRandomQuestions = () => {
    const q = [];
    const ops = ['+', '-', '*'];
    for (let i = 0; i < questionsPerLevel; i++) {
      const a = Math.floor(Math.random() * 21) - 10;
      const b = Math.floor(Math.random() * 21) - 10;
      const op = ops[Math.floor(Math.random() * ops.length)];
      const expression = `${a} ${op} ${b}`;
      const answer = eval(expression);
      q.push({ expression, answer });
    }
    return q;
  };

  const displayQuestion = () => {
    if (currentQuestion >= questionsPerLevel) {
      if (level >= levelCount) {
        setShowGameOver(true);
        return;
      }
      setLevel(prev => prev + 1);
      setCurrentQuestion(0);
      setQuestions(generateRandomQuestions());
    } else {
      setCorrectAnswer(questions[currentQuestion].answer);
    }
  };

  const submitAnswer = () => {
    const userAns = parseInt(document.getElementById('answer').value);
    if (userAns === correctAnswer) {
      setScore(prev => prev + 10);
      setFeedback('✅ Correct!');
      setTimeout(() => {
        setFeedback('');
        setCurrentQuestion(prev => prev + 1);
      }, 1000);
    } else {
      setFeedback('❌ Wrong answer, try again.');
    }
  };

  const createNumberRain = () => {
    const bg = document.getElementById('bgNumbers');
    if (!bg) return;
    for (let i = 0; i < 30; i++) {
      const num = document.createElement('div');
      num.textContent = Math.floor(Math.random() * 100);
      Object.assign(num.style, {
        position: 'absolute',
        top: '-50px',
        fontSize: '18px',
        color: '#90caf9',
        animation: `fall ${5 + Math.random() * 10}s linear infinite`,
        left: Math.random() * 100 + 'vw',
      });
      bg.appendChild(num);
    }
  };
  const formatExpression = (expr) => {
  if (!expr) return '';
  const match = expr.match(/(-?\d+)\s*([+\-*])\s*(-?\d+)/);
  if (!match) return expr;
  return `${match[1]} (${match[2]}) ${match[3]}`;
};


  return (
    <div style={{
      fontFamily: 'Arial Rounded MT Bold, sans-serif',
      background: 'linear-gradient(to bottom, #e3f2fd, #bbdefb)',
      minHeight: '100vh',
      margin: 0,
      padding: 0,
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    }}>
      <div id="bgNumbers" style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 0,
        pointerEvents: 'none'
      }}></div>
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '20px',
        width: '90%',
        maxWidth: '600px',
        textAlign: 'center',
        boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
        position: 'relative',
        zIndex: 1
      }}>
        <h2>⚔️ Integer Battle-Level <span>{level}</span></h2>
        <div style={{ marginBottom: '20px', fontSize: '18px' }}>Score: {score}</div>
        {!showGameOver ? (
          <>
            <div style={{ fontSize: '20px', marginBottom: '10px', color:"red" }}>
              {/* Q{currentQuestion + 1}: What is {questions[currentQuestion]?.expression}? */}
              Q{currentQuestion + 1}: What is {formatExpression(questions[currentQuestion]?.expression)}?

            </div>
            <div  style={{ display: 'flex', justifyContent: 'center' }} >
            <input
              type="number"
              id="answer"
              placeholder="Enter answer"
              style={{
                padding: '10px',
                fontSize: '16px',
                borderRadius: '8px',
                border: '1px solid #90caf9',
                marginBottom: '10px',
                width: '100%',
                maxWidth: '200px'
              }}
            /></div>
            <div>
              <button onClick={submitAnswer} style={{
                marginTop: '10px',
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: '#42a5f5',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer'
              }}>Attack</button>
            </div>
            <div style={{
              marginTop: '15px',
              color: feedback.includes('✅') ? 'green' : 'red',
              fontWeight: 'bold'
            }}>{feedback}</div>
          </>
        ) : (
          <>
            <div style={{ fontSize: '22px', marginBottom: '10px' }}>🏆 All levels completed!</div>
            <div style={{ fontSize: '20px' }}>Final Score: {score}</div>
          </>
        )}
      </div>

      <style>
        {`@keyframes fall {
            0% { top: -50px; opacity: 1; }
            100% { top: 100vh; opacity: 0; }
          }`}
      </style>
    </div>
  );
};

export default IntegerBattle;
